import React from 'react';
import { Space, Typography } from 'antd';

import { Session } from 'state';
import SettingsCard from '../../../TrainerSession/SessionSettingsShared/components/SettingsCard';
import MarketsViewSelect from '../../MarketsViewSelect';

type WhichMarkets = Session['which_markets'];

type Props = {
  value: WhichMarkets;
  readOnly?: boolean;
  onChange: (value: WhichMarkets) => void;
};

/** Blueprint-owned selector for the player Markets implementation. */
const BlueprintMarketsViewSettingsCard: React.FC<Props> = ({
  value,
  readOnly = false,
  onChange,
}) => (
  <SettingsCard title="Player Markets view">
    <Space orientation="vertical" size={10} style={{ width: '100%' }}>
      <Typography.Text type="secondary">
        Every player in a session launched from this blueprint receives the
        selected Markets tab. Choose Markets V5 (4) for the new centered view.
      </Typography.Text>
      <MarketsViewSelect
        value={value}
        disabled={readOnly}
        onChange={onChange}
      />
      {readOnly ? (
        <Typography.Text type="secondary">
          This blueprint version is locked, so its Markets view is read-only.
        </Typography.Text>
      ) : null}
    </Space>
  </SettingsCard>
);

export default BlueprintMarketsViewSettingsCard;
